import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './Plan.module.scss';
import { PlanSelectionStateContext } from '../../context/plan-selection-context';
import { QuestionCircle, ChevronDown, InfoCircle } from 'react-bootstrap-icons';
import { Overlay, Tooltip } from 'react-bootstrap';
import { getClassicUrl, getPathfinderUrl } from '../../SharedLib/Util/EnvironmentUtil';
import { removeCookie } from '../../SharedLib';

interface IFeature {
  text: string | JSX.Element;
  helpText: string;
}

type CardProps = {
  id: string;
  planType: string;
  planName: string;
  price: string;
  period: string;
  description: string;
  features: IFeature[];
  isSelected: boolean;
  isHorizontal?: boolean;
};

const Card: React.FC<CardProps> = ({ planType, planName, price, period, description, features, isSelected, id, isHorizontal }) => {
  const { setSelectedPlanId, purchasePlan, isLoading } = useContext(PlanSelectionStateContext);
  const [show, setShow] = useState<boolean[]>(features.map(() => false));
  const [featuresListVisible, setFeaturesListVisible] = useState(true);
  const targets = useRef<(HTMLSpanElement | null)[]>([]);

  const toggleFeaturesListVisibility = () => setFeaturesListVisible(!featuresListVisible);

  const handleSelection = () => {
    if (id !== 'classroom') {
      setSelectedPlanId(id);
    }
  };

  const handleContinue = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (id !== 'classroom') {
      if (planType === 'FREE') {
        // For free plan, just update the selected ID then redirect to pathfinder
        setSelectedPlanId('free');
        purchasePlan('free');
      } else {
        // Only call purchasePlan for paid plans
        setSelectedPlanId(id);
        if (!isLoading) {
          setTimeout(() => purchasePlan(id), 100);
        }
      }
    }
  };

  const getButtonText = () => {
    if (planType === 'FREE') {
      return `Start as ${planName} user`;
    } else if (planType === 'PLUS') {
      return `Get W3Schools ${planName}`;
    } else if (planType === 'FULL_ACCESS') {
      return `Get Full Access`;
    }
    return 'Select';
  };

  const isPlusPlan = planType === 'PLUS';
  const isFreePlan = planType === 'FREE';
  const isFullAccessPlan = planType === 'FULL_ACCESS';

  return (
    <div
      className={[
        styles.cardContainer,
        planType === 'PLUS' ? styles.plusCard : '',
        planType === 'ACADEMY' ? styles.noScaleNoPointer : '',
        isHorizontal ? styles.horizontal : '',
        planType === 'FREE' ? styles.freeCard : '',
        planType === 'FULL_ACCESS' ? styles.fullAccessCard : ''
      ].join(' ')}
      // onClick={planType !== 'ACADEMY' ? handleContinue : undefined}
    >
      <div className={styles.cardContent}>
        {planType === 'PRO' && <div className={styles.popularRibbon}>Popular</div>}
        <div className={[styles.cardHeader, planType === 'ACADEMY' ? styles.academyCardHeader : ''].join(' ')}>
          {/*planType !== 'ACADEMY' && (
            <input
              type="checkbox"
              checked={isSelected}
              className={styles.checkbox}
            />
          )*/}
          <h5 className={`${styles.cardTitle} ${planType === 'PLUS' ? styles.plus : ''}`}>{planName}</h5>

          {planType !== 'ACADEMY' && (
            <div className={styles.priceRow}>
              <span className={styles.dollar}>$</span>
              <span className={styles.cardPrice}>{price}</span>
              <span className={styles.pricePeriod}>{period}</span>
            </div>
          )}
          {planType !== 'ACADEMY' && (
            <button
              className={[
                styles.selectButton,
                isPlusPlan ? styles.plusButton : '',
                isFullAccessPlan ? styles.fullAccessBtn : '',
                isFreePlan ? styles.freeButton : '',
                isSelected ? styles.selected : ''
              ].join(' ')}
              onClick={handleContinue}
              disabled={isFreePlan ? false : isLoading}
            >
              <span>{getButtonText()}</span>
            </button>
          )}
          {planType !== 'ACADEMY' && <hr />}
        </div>
        <p className={[styles.cardDescription, planType === 'ACADEMY' ? styles.academyCardDescription : ''].join(' ')} dangerouslySetInnerHTML={{ __html: description }}></p>

        {planType === 'ACADEMY' && (
          <p className={styles.academyCardPrice}>
            <a target="_blank" href={getClassicUrl() + '/academy'} className={styles.classroomLink}>
              Read more
            </a>
          </p>
        )}

        {featuresListVisible && (
          <ul className={styles.featuresList}>
            {features.map((feature, index) => (
              <li key={index} className={styles.featureItem}>
                <>
                  {feature.text}
                  {feature.helpText && (
                    <>
                      <span
                        ref={el => (targets.current[index] = el)}
                        onMouseEnter={() => setShow(show.map((s, idx) => (idx === index ? true : s)))}
                        onMouseLeave={() => setShow(show.map((s, idx) => (idx === index ? false : s)))}
                        style={{ cursor: 'help' }}
                      >
                        &nbsp;
                        <InfoCircle style={{ marginLeft: '5px' }} />
                      </span>
                      <Overlay target={targets.current[index]} show={show[index]} placement="right">
                        {props => (
                          <Tooltip id={`tooltip-${index}`} {...props} arrowProps={{ style: { display: 'block' } }}>
                            {feature.helpText}
                          </Tooltip>
                        )}
                      </Overlay>
                    </>
                  )}
                </>
              </li>
            ))}
          </ul>
        )}

        {/*<div onClick={toggleFeaturesListVisibility} style={{ textAlign: 'center', cursor: 'pointer', transition: 'transform 0.3s' }} className={featuresListVisible ? styles.chevronUp : ''}>
          <ChevronDown />
        </div>
                        */}
      </div>
    </div>
  );
};

export default Card;
